import { ModalIOF } from '@old/ui/modal/modal';
import i18n from '../../../../libs/language';
import { Button, TextField } from '@mui/material';
import { useState } from 'react';

type MonitoredWarningExtractionModalProps = {
  open: boolean;
  setOpen: (open: boolean) => void;
  handleSave: () => void;
  monitoredSilobagIds: string[];
};

const MonitoredWarningMessage = ({ monitoredSilobagIds }: { monitoredSilobagIds: string[] }) => {
  if (monitoredSilobagIds.length === 1) {
    return (
      <>
        {i18n.t('app.vrr_no_ok_modal.siloreal')} <strong>{monitoredSilobagIds[0]}</strong>{' '}
        {i18n.t('app.vrr_no_ok_modal.monitored')}{' '}
        <strong>{i18n.t('app.vrr_no_ok_modal.irreversible')}</strong>
      </>
    );
  }

  if (monitoredSilobagIds.length > 1) {
    return (
      <>
        {i18n.t('app.vrr_no_ok_modal.siloreals')}{' '}
        {monitoredSilobagIds.map((id, index) => (
          <span key={id}>
            {index > 0 ? ', ' : ''}
            <strong>{id}</strong>
          </span>
        ))}{' '}
        {i18n.t('app.vrr_no_ok_modal.monitored_plural')}{' '}
        <strong>{i18n.t('app.vrr_no_ok_modal.irreversible')}</strong>
      </>
    );
  }

  //Ver de eliminar
  //return <>El silobolsa seleccionado se encuentra en monitoreo. ¿Deseas continuar con la operación?</>;
};

export const MonitoredWarningExtractionModal = ({
  open,
  setOpen,
  handleSave,
  monitoredSilobagIds,
}: MonitoredWarningExtractionModalProps) => {
  const [confirmationText, setConfirmationText] = useState('');

  const canContinue = confirmationText === i18n.t('app.vrr_no_ok_modal.accept');

  const handleContinue = () => {
    if (!canContinue) return;

    handleSave();
  };

  return (
    <ModalIOF open={open} ModalIsOpen={setOpen}>
      <ModalIOF.Header>
        <ModalIOF.Title>{i18n.t('app.atention')}</ModalIOF.Title>
      </ModalIOF.Header>

      <ModalIOF.Body>
        <p style={{ textAlign: 'center', fontWeight: 500 }}>
          <MonitoredWarningMessage monitoredSilobagIds={monitoredSilobagIds} />
        </p>

        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            marginTop: 20,
          }}
        >
          <TextField
            label={i18n.t('app.vrr_no_ok_modal.accept_writing')}
            value={confirmationText}
            onChange={(event) => setConfirmationText(event.target.value)}
            fullWidth
            size="small"
          />
        </div>
      </ModalIOF.Body>

      <div
        style={{
          display: 'flex',
          justifyContent: 'flex-end',
          alignItems: 'center',
          gap: 12,
          marginTop: 8,
        }}
      >
        <ModalIOF.Button
          close
          variant="text"
          size="medium"
          sx={{
            color: '#374151',
            fontWeight: 600,
            textTransform: 'none',
            boxShadow: 'none',
            '&:hover': {
              backgroundColor: 'transparent',
              color: '#111827',
            },
          }}
          onClick={() => {}}
        >
          {i18n.t('app.cancel')}
        </ModalIOF.Button>

        <Button
          variant="contained"
          size="medium"
          onClick={handleContinue}
          disabled={!canContinue}
          sx={{
            bgcolor: '#6BAA00',
            color: '#fff',
            fontWeight: 600,
            borderRadius: '20px',
            px: 3,
            textTransform: 'none',
            boxShadow: 'none',
            '&:hover': { bgcolor: '#5a9300', boxShadow: 'none' },
            '&.Mui-disabled': { bgcolor: '#6BAA0066', color: '#fff' },
          }}
        >
          {i18n.t('app.continue')}
        </Button>
      </div>
    </ModalIOF>
  );
};
